import React, { useState } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Icon } from 'semantic-ui-react'
import ReactTable from 'react-table'
import moment from 'moment'
import { CSVLink } from 'react-csv'
import { ProcurementContainer, ProcurementBody } from 'routes/ProcurementSystem/styled'
import { BGListContainer } from './styled'
import { getBGCompany, exportBGCData } from 'ducks/bgCompany'
import { getVendors, getCompanies, getCustomers } from 'ducks/options'
import { columnsCompany, search_statusOption, exportColumn } from './AttributeData'
import { 
  bgCompanyReportDetailPath, 
  bgCompanyReportEditPath
} from 'routes'
import { 
  MainBodyContent, 
  SearchList, 
  TablePagination,
  CustomButton
} from 'components'

const BGCompanyReport = (props) => {
  const { 
    bgCompanyLists, 
    valueForm,
  } = props

  const userPageSize = parseInt(localStorage.getItem('userPageSize') || '10')
  const [pageSize, setPageSize] = useState(userPageSize)

  React.useEffect(() => {
    window.scrollTo(0, 0)
    props.getBGCompany({ page: 1, size: pageSize })
    props.getVendors()
    props.getCompanies()
    props.getCustomers()
  }, [])

  return (
    <MainBodyContent 
      headerTitle='Bank Guarantee Report'
      accessoriesHeader={
        <React.Fragment>
          <CSVLink
            id='export_bgc_link_id'
            data={props.bgcExport}
            filename={`BGC_Reports_${moment(new Date()).format('DDMMYYYY-HHmm')}.csv`}
            headers={exportColumn}
          ></CSVLink>
          <CustomButton
            onClick={() => {
              props.exportBGCData({ ...valueForm }, () => { 
                var element = document.getElementById('export_bgc_link_id')
                if (element) element.click()
              })
            }}
            icon='download'
            btnColor='blue'
            title='Export Data' />
        </React.Fragment>
      }
    >
      <ProcurementContainer>
        <ProcurementBody>
          <SearchList 
            placeholder='Doc No., Title, Bank Guarantee Number' 
            fetchAPI={props.getBGCompany} 
            formSearchName='formSearchBGCompany' 
            filterStatus
            filterCompany
            filterVendor
            filterCustomer
            hideProject
            pageSize={pageSize}
            filterStatusOptions={search_statusOption}
          />
          <BGListContainer>
            <ReactTable
              data={bgCompanyLists.data ? bgCompanyLists.data : []}
              columns={columnsCompany()}
              defaultPageSize={userPageSize}
              noDataText='No bank guarantee data.'
              previousText={<Icon name='arrow alternate circle left' />}
              nextText={<Icon name='arrow alternate circle right' />}
              className='-striped -highlight'

              PaginationComponent={TablePagination}
              pages={bgCompanyLists.totalPage ? bgCompanyLists.totalPage : 0}
              currentPage={bgCompanyLists.page ? bgCompanyLists.page : 0}
              onPageChange={(pageIndex) => {
                props.getBGCompany({ ...valueForm, page: pageIndex + 1, size: pageSize })
              }}
              onPageSizeChange={(pageSize, pageIndex) => {
                setPageSize(pageSize)
                localStorage.setItem('userPageSize', pageSize)
                props.getBGCompany({ ...valueForm, page: pageIndex + 1, size: pageSize })
              }}

              getTdProps={(state, rowInfo, column, instance) => {
                return {
                  onClick: (e, handleOriginal) => {
                    if (rowInfo && column && column.Header !== '') {
                      if ([0].indexOf(Number(rowInfo.original.status)) >= 0) {
                        window.open(bgCompanyReportEditPath(rowInfo.original.id))
                      } else {
                        window.open(bgCompanyReportDetailPath(rowInfo.original.id))
                      }
                    }
                    if (handleOriginal) {
                      handleOriginal()
                    }
                  },
                }
              }}
            />
          </BGListContainer>
        </ProcurementBody>
      </ProcurementContainer>
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => {
  return ({
    valueForm: getFormValues('formSearchBGCompany')(state),
    bgCompanyLists: state.bgCompany.lists.data,
    bgcExport: state.bgCompany.bgcExport.data,
  })
}

const mapDispatchToProps = {
  getBGCompany,
  getVendors, 
  getCompanies,
  getCustomers,
  exportBGCData
}

const contForm = reduxForm({
  form: 'formSearchBGCompany',
  enableReinitialize: true,
})(BGCompanyReport)

export default connect(mapStateToProps, mapDispatchToProps)(contForm)